<template>
  <div class="json-editor">
    <div class="ui modal" ref="modal">
      <div class="header">{{ title }}</div>
      <div class="scrolling content">
        <div class="ui padded grid">
          <div class="row">
            <div class="sixteen wide column">
              <form @submit.prevent="save()" class="ui small form search-form">
                <div class="field">
                  <label>{{ label }}</label>
                  <textarea name="json" v-model="json"></textarea>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="actions">
        <button @click.prevent="hide" class="ui deny button">Cancelar</button>
        <button @click.prevent="save" class="ui positive right button">
          Atualizar
        </button>
      </div>
    </div>
    <slot name="activator" :open="open" />
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'JSONEditor',
  props: {
    title: {
      type: String,
      default: 'Editar JSON'
    },
    label: {
      type: String,
      default: 'JSON'
    },
    value: {
      type: Object,
      default: () => {}
    }
  },

  data: function () {
    return {
      json: JSON.stringify(this.value)
    };
  },

  methods: {
    open() {
      window.$(this.$refs.modal).modal('show');
    },

    hide() {
      window.$(this.$refs.modal).modal('hide');
    },

    save() {
      try {
        const jsonObj = JSON.parse(this.json);
        this.$emit('save', jsonObj);
        this.hide();
      } catch (e) {
        this.$toast.show('JSON inválido', 'error');
        throw e;
      }
      // this.$emit('save', this.json);
    }
  }
};
</script>
